import PropTypes from 'prop-types';

import Tag from '#globalComponents/Tag/Tag';
import TruncatedText from '#globalComponents/TruncatedText/TruncatedText';

import { enumFilterLabel } from '../../../constants/leadFilters';

const buildProfileTags = (lead, vocabulary) => {
	const filterGrade = lead.websiteProfile?.facets?.filterGrade ?? {};
	const customerTypes = filterGrade.customerTypes ?? [];
	return [
		filterGrade.businessModel && {
			key: 'businessModel',
			label: enumFilterLabel('businessModel', filterGrade.businessModel, vocabulary),
			tone: 'primary',
		},
		customerTypes.length > 0 && {
			key: 'customerTypes',
			label: customerTypes.map((value) => enumFilterLabel('customerType', value, vocabulary)).join(', '),
			tone: 'neutral',
		},
		(lead.hiringActive === true || filterGrade.hiringWebsite === true) && {
			key: 'hiring',
			label: 'stellt ein',
			tone: 'success',
		},
	].filter(Boolean);
};

/** "Profil" cell of the leads table: one-liner and the most telling website-profile facets. */
const LeadProfileCell = ({ lead, vocabulary }) => {
	const oneLiner = lead.websiteProfile?.oneLiner;
	const tags = buildProfileTags(lead, vocabulary);
	if (!oneLiner && tags.length === 0) return <span>–</span>;

	return (
		<div className="min-w-0 space-y-1">
			{oneLiner && <TruncatedText text={oneLiner} className="text-sm text-text" />}
			{tags.length > 0 && (
				<div className="flex flex-wrap gap-1">
					{tags.map((tag) => (
						<Tag key={tag.key} label={tag.label} tone={tag.tone} size="xs" />
					))}
				</div>
			)}
		</div>
	);
};

LeadProfileCell.propTypes = {
	lead: PropTypes.shape({
		hiringActive: PropTypes.bool,
		websiteProfile: PropTypes.shape({
			oneLiner: PropTypes.string,
			facets: PropTypes.object,
		}),
	}).isRequired,
	vocabulary: PropTypes.object,
};

export default LeadProfileCell;
